import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/horn-down.png'
import _imports_1 from '@/assets/horn-up.png'


const _withScopeId = n => (_pushScopeId("data-v-81195440"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "volume-setting" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

import _ from "lodash";
import { platform } from "@/services/platform";
import { onMounted, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const setSystemVolume = _.throttle(
  async (volume: any) => {
    // await platform.setMuted(true);
    if (volume === 0) {
      await platform.setMuted(false);
    } else {
      systemVolume.volume += volume;
      if (systemVolume.volume > 100) {
        systemVolume.volume -= volume;
        return;
      }
      if (systemVolume.volume < 0) {
        systemVolume.volume -= volume;
        return;
      }
      console.log(`设置系统音量:${volume}`);
      await platform.setVolume(systemVolume.volume);
    }
    // changeVolumeView(volume);
  },
  500,
  { leading: true }
);

const systemVolume = reactive({
  volume: 0,
  max: 1,
  min: 0,
});

const getSystemVolume = async () => {
  const volume = await platform.getVolume();
  console.log(`获取系统音量:${volume}`);
  systemVolume.volume = volume || 60;
  systemVolume.min = 0;
  systemVolume.max = 100;
  // changeVolumeView(systemVolume.volume);
};
onMounted(async () => {
  await getSystemVolume();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "volume-btn volume-down",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setSystemVolume)(-5)))
    }, _hoisted_3),
    _createElementVNode("div", {
      class: "volume-btn volume-up",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(setSystemVolume)(5)))
    }, _hoisted_5)
  ]))
}
}

})